import React, { useRef } from "react";
import Box from "@mui/material/Box";
import { useStyles } from "./productGridStyles";
import Card from "./Card/Card";
import { IProductGrid } from "./IProductGrid";
import { IProductGridItem } from "../../services/interface/data";
const ProductGrid = ({ headline, subHeadline, products }: IProductGrid) => {
    const { classes } = useStyles();
    const root = useRef(null);

    return (
        <Box data-name="ProductGrid" ref={root} className={classes.root}>
            {products?.map((product: IProductGridItem, index: number) => (
                <Card
                    key={`product-grid-card-${index}`}
                    index={index + 1}
                    eyebrow={product.eyebrow}
                    description={product.description}
                    background={product.background}
                    sku={product.sku}
                    attributes={product.attributes}
                />
            ))}
        </Box>
    );
};

export default ProductGrid;
